import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/Layout/MainLayout';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Users from './pages/Users/Users';
import UserForm from './pages/Users/UserForm';
import UserDetail from './pages/Users/UserDetail';
import Forums from './pages/Forums/Forums';
import ForumForm from './pages/Forums/ForumForm';
import Categories from './pages/Categories/Categories';
import CategoryForm from './pages/Categories/CategoryForm';
import Characters from './pages/Characters/Characters';
import CharacterForm from './pages/Characters/CharacterForm';
import CharacterDetail from './pages/Characters/CharacterDetail';
import Factions from './pages/Factions/Factions';
import FactionForm from './pages/Factions/FactionForm';
import Univers from './pages/Univers/Univers';
import UniverseForm from './pages/Univers/UniverseForm';
import Elseworlds from './pages/Elseworlds/Elseworlds';
import ElseworldForm from './pages/Elseworlds/ElseworldForm';
import ImportantRegulation from './pages/Important/ImportantRegulation';
import ImportantGuide from './pages/Important/ImportantGuide';
import ImportantVote from './pages/Important/ImportantVote';
import ImportantMemberOfMonth from './pages/Important/ImportantMemberOfMonth';
import ImportantCharacterOfMonth from './pages/Important/ImportantCharacterOfMonth';
import AnimationNpcs from './pages/AnimationNpcs/AnimationNpcs';
import AnimationNpcForm from './pages/AnimationNpcs/AnimationNpcForm';
import AnimationNpcDetail from './pages/AnimationNpcs/AnimationNpcDetail';
import Mediatheque from './pages/Mediatheque/Mediatheque';
import ImportantSeoPortal from './pages/Important/ImportantSeoPortal';
import ImportantAbout from './pages/Important/ImportantAbout';
import ImportantSeoUniverses from './pages/Important/ImportantSeoUniverses';
import ImportantSeoFeatures from './pages/Important/ImportantSeoFeatures';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { UniverseProvider } from './contexts/UniverseContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/users" element={<Users />} />
                <Route path="/users/new" element={<UserForm />} />
                <Route path="/users/edit/:id" element={<UserForm />} />
                <Route path="/users/:id" element={<UserDetail />} />
                <Route path="/forums" element={<Forums />} />
                <Route path="/forums/new" element={<ForumForm />} />
                <Route path="/forums/edit/:id" element={<ForumForm />} />
                <Route path="/forum-categories" element={<Categories />} />
                <Route path="/forum-categories/new" element={<CategoryForm />} />
                <Route path="/forum-categories/edit/:id" element={<CategoryForm />} />
                <Route path="/characters" element={<Characters />} />
                <Route path="/characters/new" element={<CharacterForm />} />
                <Route path="/characters/edit/:id" element={<CharacterForm />} />
                <Route path="/characters/detail/:id" element={<CharacterDetail />} />
                <Route path="/animation-npcs" element={<AnimationNpcs />} />
                <Route path="/animation-npcs/new" element={<AnimationNpcForm />} />
                <Route path="/animation-npcs/edit/:id" element={<AnimationNpcForm />} />
                <Route path="/animation-npcs/detail/:id" element={<AnimationNpcDetail />} />
                <Route path="/factions" element={<Factions />} />
                <Route path="/factions/new" element={<FactionForm />} />
                <Route path="/factions/edit/:id" element={<FactionForm />} />
                <Route path="/univers" element={<Univers />} />
                <Route path="/univers/edit/:id" element={<UniverseForm />} />
                <Route path="/elseworlds" element={<Elseworlds />} />
                <Route path="/elseworlds/new" element={<ElseworldForm />} />
                <Route path="/elseworlds/edit/:id" element={<ElseworldForm />} />
                <Route path="/important/regulation" element={<ImportantRegulation />} />
                <Route path="/important/guide" element={<ImportantGuide />} />
                <Route path="/important/portal-seo" element={<ImportantSeoPortal />} />
                <Route path="/important/about" element={<ImportantAbout />} />
                <Route path="/important/universe-seo" element={<ImportantSeoUniverses />} />
                <Route path="/important/features-seo" element={<ImportantSeoFeatures />} />
                <Route path="/important/vote" element={<ImportantVote />} />
                <Route path="/important/member-of-month" element={<ImportantMemberOfMonth />} />
                <Route path="/important/character-of-month" element={<ImportantCharacterOfMonth />} />
                <Route path="/mediatheque" element={<Mediatheque />} />
              </Routes>
            </MainLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <UniverseProvider>
          <AppRoutes />
        </UniverseProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;

